var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61_00000122720702639921164940000004409912701813640338_",
    transform: "translate(3050.019 3900.049)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2_00000041276805496748660410000011926705626457152128_",
    fill: "none",
    stroke: "#E89E9E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: -3026.019,
    cy: -3876.049,
    r: 21
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\xEDnea_36_00000103234186732067597690000014739268495161544619_",
    fill: "none",
    stroke: "#E89E9E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: -3015.025,
    y1: -3865.055,
    x2: -3037.013,
    y2: -3887.043
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\xEDnea_37_00000010297200302503566140000001850323780102980517_",
    fill: "none",
    stroke: "#E89E9E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: -3037.013,
    y1: -3865.055,
    x2: -3015.025,
    y2: -3887.043
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 48,
    height: 48
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/CLOSE.0bd0945d.svg";
export { ForwardRef as ReactComponent };